<template>
  <div style="width:100%;float:left;">
    <!-- <div style="width:100%;float:left;">
      <search-orders></search-orders>
    </div> -->
    <div style="width:100%;float:left;">
      <CCard>
        <CCardHeader>
          Open Orders
          <div style="float:right;">
            <v-select style="width:200px;" :options="orderOptions" name="name" v-model="orderOptionSelected"></v-select>
            <!-- <input type="checkbox" v-model="showAll" @change="getOrders()"> Show All (not only open orders)</input> -->
          </div>
        </CCardHeader>
        <CCardBody>
          <div class="all text-center" v-if="showAll">
            <v-select style="width:200px;float:right;" :options="filterOptions" name="name" v-model="filter"></v-select>
          </div>
          <!-- <h5 style="width:100%;float:left;text-align: center;font-size:13px;">Click on row to go to order</h5> -->
          <div style="width:100%;float:left;text-align: center;">
            <!-- <v-select style="width:500px;margin-left:auto;margin-right:auto;" placeholder="Select Customer" v-if="customerOptions" :options="customerOptions" name="name" label="label" v-model="customerFilter"></v-select> -->
            <CButton size="sm" class="mt-2" color="info" v-if="!downloadLoading" :disabled="selected.length ? false : true" @click="downloadOrders()">Combine & Email Selected PDF Orders (Max 30)</CButton>
          </div>
          <spacer />
          <!-- <div style="width:100%;float:left;" v-if="orders">{{orders.length}} Orders Showing</div> -->
          <div style="width:100%;float:left;" v-if="!loading">
            <CDataTable v-if="orders"
              :items="orders"
              :fields="fields"
              :items-per-page="15"
              pagination
              column-filter
              sorter
              table-filter
            >
              <template #check-header>
                  <input type="checkbox" :checked="checkAll()" @click="selectAll()" />
              </template>
              <template #local_created_at-header>
                  Entered On
              </template>
              <template #order_id-header>
                  Order#
              </template>
              <template #as400_log_number-header>
                  Log#
              </template>
              <template #order_items="{item}">
                <td>
                  {{ item.item_count }}
                </td>
              </template>
              <template #check="{item}">
                <td>
                  <input type="checkbox" :checked="checkSelected(item)" @click="changeSelected(item)" />
                </td>
              </template>
              <template #po_number="{item}">
                <td>
                  {{ item.po_number }}
                </td>
              </template>
              <template #price="{item}">
                <td>
                  ${{ parseFloat(item.price).toFixed(2) }}
                </td>
              </template>
              <!-- <template #customer="{item}">
                <td>
                  {{ item.order.customer_info.customer_name }}
                </td>
              </template> -->
              <template #status="{item}">
                <td>
                  <CBadge :color="configureColor(item)">{{ item.status }}</CBadge>
                </td>
              </template>
              <template #show="{item}">
                <td>
                  <div style="width:100px;">
                    <CButton size="sm" style="float:left;" color="primary" @click="quickView( item )"><CIcon name="cil-fullscreen" /></CButton>
                    <CButton size="sm" style="float:left;" color="success" @click="goToOrder( item )"><CIcon name="cil-arrow-right" /></CButton>
                  </div>
                </td>
              </template>
            </CDataTable>
          </div>
          <small-loader v-else></small-loader>
        </CCardBody>
        </CCard>
      </div>
      <adobe-pdf-viewer v-if="pdfModal && pdfData" @closed="pdfModal = false, pdfData = null" :order_group="pdfData" pdf_type="either" :allowEdit="false"></adobe-pdf-viewer>
  </div>
</template>
<script>
import SearchOrders from './../components/search_orders'
import AdobePdfViewer from './../components/adobe_pdf_viewer'
var methods = {}

methods.rowClicked = function (item) {
  this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
}

methods.quickView = function (item) {
  this.pdfData = item
  this.pdfModal = true
}

methods.checkSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    return 1
  } else {
    return 0
  }
}

methods.checkAll = function () {
  if (this.selected.length) {
    return 1
  } else {
    return 0
  }
}

methods.changeSelected = function (item) {
  if (this.selected.indexOf(item.order_group_id) > -1) {
    this.selected.splice(this.selected.indexOf(item.order_group_id), 1)
  } else {
    this.selected.push(item.order_group_id)
  }
}

methods.selectAll = function () {
  if (this.selected.length) {
    this.selected = []
  } else {
    var arr = []
    this.orders.forEach(function (val) {
      arr.push(val.order_group_id)
    })
    this.selected = arr
  }
}

methods.downloadOrders = function () {
  this.downloadLoading = true
    const postData = {
      orders: this.selected
    }
    axios.post(this.$apiAdress + '/api/orders/downloadAllOrdersOnPdf?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      this.downloadLoading = false
      window.Swal.fire({
        type: 'success',
        title: 'Success',
        text: 'You will be emailed the orders shortly.'
      })
      this.selected = []
    }).catch(e => {
      console.log(e)
      window.Swal.fire({
        type: 'error',
        title: 'Error!',
        text: 'Something went wrong, please contact acoleman@paifashion.com if it keeps happening.'
      })
    })
}

methods.getOrders = function () {
  this.loading = true
  const postData = {
    filter: this.filter,
    customer: this.customer_selected,
    showAll: this.showAll
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/getMyRepOrders?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    // this.orders = response.data
    var arr = []
    // response.data.forEach(function (val) {
    //   var obj = {}
    //   for (var key in val) {
    //     obj[key] = val[key]
    //   }
    //   // obj.po_number = val.order.po_number
    //   obj.customer_name = val.order.customer_info.customer_name
    //   obj.checked = 0
    //   // obj.rep_name = val.order.rep.name
    //   arr.push(obj)
    // })
    this.orders = response.data
    this.selected = []
    this.loading = false
    this.$emit('orders-loaded', true)
  })
}

methods.goToOrder = function (item) {
  // this.$router.push('/order/' + item.order_id + '/' + item.order_group_id)
  window.open(this.$hostAddress + 'order/' + item.order_id + '/' + item.order_group_id, '_blank')
}

methods.configureColor = function (item) {
  if (item) {
    var percent = ''
    switch(item.status) {
      case 'Entered': {
        percent = 'info'
        break
      }
      case 'Needs Entered': {
        percent = 'secondary'
        break
      }
      case 'Waiting On Customer': {
        percent = 'danger'
        break
      }
      case 'Received': {
        percent = 'info'
        break
      }
      case 'In Process': {
        percent = 'danger'
        break
      }
      case 'Shipped': {
        percent = 'success'
        break
      }
      case 'On Hold': {
        percent = 'warning'
        break
      }
      case 'Voided': {
        percent = 'warning'
        break
      }
      case 'Canceled': {
        percent = 'danger'
        break
      }
      default: {
        percent = ''
        break
      }
    }
    return percent
  } else {
    return 0
  }
}

methods.getCustomers = function () {
  let self = this
  // this.topLoading = true
  var repNum = ''
  
  const postData = {
    rep_number: this.$store.state.user.rep_number
  }
  axios.post( this.$apiAdress + '/api/getRepCustomers?token=' + localStorage.getItem("api_token"), postData)
  .then(function (response) {


    // self.customerOptions = response.data
    self.customerOptions = []
    response.data.forEach(function (val) {
      var obj = {}
      for (var key in val) {
        obj[key] = val[key]
      }
      obj.label = val.customer_name + ' - ' + val.customer_number
      self.customerOptions.push(obj)
    })
  }).catch(function (error) {
    // self.topLoading = false
  });
}

export default {
    // ===Component name
    name: "CSRTable",
    // ===Props passed to component
    props: ['fromDash', 'customer_selected'],
    // ===Components used by this component
    components: {
      SearchOrders,
      AdobePdfViewer
    },
    // ====component Data properties
    data(){
        return{
          orders: null,
          fields: ['check', 'as400_log_number', 'po_number', 'customer_name', 'order_items', 'ship_date', 'local_created_at', 'units', 'price', 'program_name', 'status','show'],
          filter: 'Last 15 Days',
          filterOptions: ['Last 15 Days', 'Last 30 Days', 'Last 60 Days', 'All'],
          orderOptionSelected: 'Open Orders',
          orderOptions: ['Open Orders', 'POs Shipped', 'Recent Orders'],
          loading: true,
          customerOptions: null,
          customerFilter: '',
          downloadLoading: false,
          selected: [],
          showAll: false,
          startDate: '',
          endDate: '',
          pdfModal: false,
          pdfData: null,
        }
    },
    watch: {
      'customerFilter': function (newVal, oldVal) {
        localStorage.setItem('customer_selected', JSON.stringify(this.customerFilter))
        this.getOrders()
        console.log('getting orders on customer filter change')
      },
      'filter': function (newVal, oldVal) {
        this.getOrders()
        console.log('getting orders on filter change')
      }
      // 'startDate': function (newVal, oldVal) {
      //   if (oldVal) {
      //     this.getOrders()
      //   }
      // },
      // 'endDate': function (newVal, oldVal) {
      //   if (oldVal) {
      //     this.getOrders()
      //   }
      // }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.getOrders()
      console.log('getting orders from mounted')
      // this.startDate = moment().subtract(1, 'months').format('YYYY-MM-DD')
      // this.endDate = moment().format('YYYY-MM-DD')
      // this.checkCustomer().then(res => {
      //   this.getOrders()
      //   this.getCustomers()
      // })
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
